import React from "react";

function CustomSoftwareDevelopment() {
  return (
    <div className="collaborate-bg mt-5">
      <div className="container">
        <div className="row justify-content-center align-items-center">
          <div className="col-lg-8 col-md-12 col-sm-12 mt-5 mb-5">
            <h1 className="Text-heading text-center mt-5" data-aos="fade-up">
              Leave Custom Software Development to Us
            </h1>
            <p className="mt-2 text-detail text-center" data-aos="fade-up">
              Virtual Tech is delighted to contribute to your success story and
              accelerate your company progress with cutting-edge IT solutions.
            </p>
            <div className="text-center" data-aos="fade-up">
              <button className="btn btn-experts p-3">Schedule A Call</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CustomSoftwareDevelopment;
